import { createRequestActionTypes } from '../../helpers'

export const O_FETCH_SUGGESTIONS = createRequestActionTypes(
  'O_SEARCH',
  'O_FETCH_SUGGESTIONS'
)
export const O_FETCH_SEARCH = createRequestActionTypes(
  'O_SEARCH',
  'O_FETCH_SEARCH'
)
